import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard, ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

function ListEvents({ header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:moderation:event:list"));

    if (!apiData) return;

    const moderationState = {
        material_request: "Запрос материалов",
        marketing_review: "Маркетинговое ревью",
        material_rejected: "Материалы отклонены",
        review: "Ревью",
    };
    return (
        <ListingCard header={header}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Игра")}</th>
                        <th>{t("Статус")}</th>
                        <th>{t("Ивенты")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => (
                        <tr key={`object_list${o.id}`}>
                            <td>
                                <Link
                                    to={url_reverse("admin:moderation:event:game", {
                                        event_slug: o.__event.slug,
                                        game_id: o.game.id,
                                    })}
                                >
                                    {o.game.base_locale_object.name}
                                </Link>
                            </td>
                            <td>{moderationState[o.moderation_state]}</td>
                            <td>{o.__event.name}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function ModerateEvent({ game_id, event_slug }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:moderation:event:game", { event_slug, game_id }));

    if (!apiData) return;

    const header = (
        <>
            <Link to={url_reverse("admin:moderation:event:list")}>{t("Ивенты")}</Link>
            <span> – </span>
            <Link to={url_reverse("games:admin", { game_id: apiData.game.game_id, locale: apiData.game.base_locale })}>
                {apiData.game.name}
            </Link>
        </>
    );

    return (
        <CommonCard header={header}>
            <RenderForm
                hideInputs={true}
                backUrl={url_reverse("admin:moderation:event:list")}
                submitButtonText={t("Завершить проверку")}
            />
        </CommonCard>
    );
}

export default function EventModerationScreen() {
    const { t } = useTranslation();
    const params = useParams();
    const header = t("Модерация ивентов");

    return (
        <DefaultLayout>
            {params?.game_id ? (
                <ModerateEvent game_id={params.game_id} event_slug={params.event_slug} />
            ) : (
                <ListEvents header={header} />
            )}
        </DefaultLayout>
    );
}
